import { request } from '@/utils/request'

export function appthirdprobation (params) {
  return request({
    url: 'patrolwwkj/appthirdprobation/create',
    method: 'get',
    params: params
  })
}